<template>
  <v-app-bar
    :clipped-left="$vuetify.breakpoint.lgAndUp"
    app
    color="primary"
    dark
    elevate-on-scroll
  >
    <v-progress-linear
      :active="isAppLoading"
      :indeterminate="true"
      absolute
      :top="true"
      color="accent"
    ></v-progress-linear>

    <v-toolbar-title style="width: 300px">
      <v-app-bar-nav-icon @click.stop="toggleDrawer" class="mr-2" />
      <span class="hidden-sm-and-down">{{
        currentUser ? currentUser.company : "NEXUS"
      }}</span>
    </v-toolbar-title>
    <v-spacer />

    <v-card
      class="d-inline-flex pa-2"
      min-width="200px"
      width="130"
      flat
      color="transparent"
    >
      <v-select
        :items="centerList"
        v-model="selectedCenter"
        menu-props="auto"
        :label="this.terminologies.center"
        hide-details
        return-object
        item-text="name"
        item-value="id"
        @change="changeCenter"
        prepend-icon="mdi-office-building-marker-outline"
      ></v-select>
    </v-card>
    <v-menu v-if="modules && modules.length > 0" offset-y>
      <template v-slot:activator="{ on, attrs }">
        <v-btn tile large icon v-bind="attrs" v-on="on">
          <v-icon>mdi-dots-grid</v-icon>
        </v-btn>
      </template>
      <v-card class="mx-auto" max-width="400" width="300" tile>
        <v-card-text>
          <v-row>
            <v-col
              v-for="module in modules"
              :key="module.id"
              style="text-align: center"
              cols="6"
            >
              <v-hover v-slot="{ hover }">
                <v-sheet
                  @click="toApp(module)"
                  :elevation="hover ? 16 : 0"
                  :class="{ 'on-hover': hover }"
                >
                  <v-icon size="50" :color="module.color">
                    {{ module.icon }} </v-icon
                  ><br />
                  {{ module.name }}
                </v-sheet>
              </v-hover>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-menu>

    <v-btn data-cy="login" to="/login" v-if="!isLoggedIn" icon title="Login">
      <v-icon>mdi-login</v-icon>
    </v-btn>
    <div v-if="currentUser" class="text-center">
      <v-menu offset-y>
        <template v-slot:activator="{ on, attrs }">
          <v-btn class="ma-2" tile large icon v-bind="attrs" v-on="on">
            <v-icon>mdi-shield-account</v-icon>
          </v-btn>
        </template>

        <v-card class="mx-auto" max-width="400" width="200" tile>
          <v-list dense>
            <v-list-item-group v-model="menuItem" color="primary">
              <v-list-item disabled>
                <v-list-item-title>
                  {{ currentUser.firstName }} {{ currentUser.lastName }}
                </v-list-item-title>
              </v-list-item>
              <v-list-item
                @click="openSwitchUserDialog"
                :disabled="loadingUsers"
              >
                <v-list-item-icon class="mr-2">
                  <v-progress-circular
                    v-if="loadingUsers"
                    indeterminate
                    size="20"
                    width="2"
                    color="primary"
                  ></v-progress-circular>
                  <v-icon v-else>mdi-account-switch</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>
                    {{ loadingUsers ? "Loading..." : "Switch Account" }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item
                :to="item.link"
                v-for="(item, i) in userMenu"
                :key="i"
              >
                <v-list-item-icon class="mr-2">
                  <v-icon v-text="item.icon"></v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title v-text="item.text"></v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item @click="logout">
                <v-list-item-icon class="mr-2">
                  <v-icon>mdi-logout</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>Logout</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-card>
      </v-menu>
    </div>
    <v-dialog v-model="switchUserDialog" max-width="500px" persistent>
      <v-card>
        <v-card-title class="headline">
          Switch Account
          <v-spacer></v-spacer>
          <v-progress-circular
            v-if="loadingUsers"
            indeterminate
            size="24"
            width="2"
            color="primary"
          ></v-progress-circular>
        </v-card-title>
        <v-card-text>
          <div v-if="loadingUsers" class="text-center py-4">
            <v-progress-circular
              indeterminate
              size="40"
              width="3"
              color="primary"
            ></v-progress-circular>
            <p class="mt-3 text-body-2 grey--text">
              Loading available users...
            </p>
          </div>
          <div
            v-if="!loadingUsers && availableUsers.length === 0"
            class="text-center py-4"
          >
            <v-icon size="48" color="grey lighten-1">mdi-account-off</v-icon>
            <p class="mt-3 text-body-2 grey--text">
              No other users available to switch to.
            </p>
          </div>
          <v-radio-group
            v-else-if="!loadingUsers && availableUsers.length > 0"
            v-model="selectedUser"
          >
            <v-radio
              v-for="user in availableUsers"
              :key="user.id"
              :label="user.name"
              :value="user.id"
              :disabled="switchingUser"
            >
              <template v-slot:label>
                <div>
                  <div>{{ user.name }}</div>
                  <div class="text-caption grey--text">{{ user.email }}</div>
                </div>
              </template>
            </v-radio>
          </v-radio-group>
          <div v-if="switchingUser" class="text-center py-4">
            <v-progress-circular
              indeterminate
              size="40"
              width="3"
              color="primary"
            ></v-progress-circular>
            <p class="mt-3 text-body-2 grey--text">Switching account...</p>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="switchUserDialog = false"
            :disabled="loadingUsers || switchingUser"
          >
            Cancel
          </v-btn>
          <v-btn
            color="primary"
            :disabled="
              !selectedUser ||
              loadingUsers ||
              switchingUser ||
              availableUsers.length === 0
            "
            :loading="switchingUser"
            @click="switchUser(selectedUser)"
          >
            Switch
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-app-bar>
</template>

<script>
import { parseDomain } from "parse-domain";
import { mapActions, mapGetters } from "vuex";

export default {
  data: () => ({
    selectedCenter: null,
    centerList: [],
    drawer: null,
    menuItem: 1,
    userMenu: [
      // {
      //   text: "My Home",
      //   link: "/secure/myhome",
      //   icon: "mdi-account",
      // },
    ],
    modules: [],
    switchUserDialog: false,
    availableUsers: [],
    selectedUser: null,
    loadingUsers: false,
    switchingUser: false,
    switchUserMessage: "",
  }),
  computed: {
    ...mapGetters("auth", ["isLoggedIn", "currentUser"]),
    ...mapGetters("navigation", ["isAppLoading", "globalCenter"]),
    ...mapGetters("terminology", ["terminologies"]),
  },
  async mounted() {
    //check jwt token all each page reload
    await this.remoteJwtTokenCheck();
    await this.fetchAvailableUsers();

    if (!this.currentUser) return;

    this.initCenters()
      .then((centers) => {
        this.centerList = centers;
        if (this.centerList && this.centerList.length > 1) {
          this.centerList.unshift({
            id: null,
            name: "All Locations",
            accountId: this.centerList[0].accountId,
          });
        }
        this.setMyCenters(centers);

        this.selectedCenter = this.globalCenter;
        if (centers && centers.length > 0) {
          const existIndex = centers.findIndex(
            (c) => this.selectedCenter && c.id == this.selectedCenter.id,
          );
          if (!existIndex || existIndex < 0) {
            this.selectedCenter = centers[0];
            this.setCenter(this.selectedCenter);
          }
        }
      })
      .finally(() => {
        this.$emit("load", this.selectedCenter);
      });

    this.initModules().then((modules) => {
      if (modules) {
        this.modules = modules.filter(
          (m) => m.path !== process.env.VUE_APP_MODULE,
        );
      }
    });
  },
  methods: {
    ...mapActions("auth", [
      "processLogout",
      "setMyCenters",
      "remoteJwtTokenCheck",
    ]),
    ...mapActions("navigation", ["toggleDrawer", "hideDrawer", "setCenter"]),

    logout() {
      this.$axios.post("gaa-user/signout").then(() => {
        this.processLogout();
        delete this.$axios.defaults.headers.common["Authorization"];
        this.$router.push({ name: "Login" });
      });
    },
    changeCenter() {
      this.setCenter(this.selectedCenter);
      this.$router.go();
    },
    async initCenters() {
      return await this.$axios.get("/center/get-my-centers").then((resp) => {
        const centers = resp.data;
        return centers;
      });
    },
    async initModules() {
      return await this.$axios
        .get("/user/module", { params: { user_id: this.currentUser.uId } })
        .then((resp) => {
          return resp.data;
        });
    },
    toApp(app) {
      if (process.env.NODE_ENV != "development") {
        const parseResult = parseDomain(window.location.hostname);
        const { domain, topLevelDomains } = parseResult;
        const topLevel = topLevelDomains.join(".");

        const moduleUrl = `https://${app.path}.${domain}.${topLevel}`;
        window.location.href = moduleUrl;
      }
    },
    async fetchAvailableUsers() {
      this.loadingUsers = true;
      try {
        const response = await this.$axios.get("/jwt-token-check");
        if (response.data && response.data.availableAccounts) {
          this.availableUsers = response.data.availableAccounts.map(
            (account) => ({
              id: account.id,
              name: account.name,
              email: response.data.email,
            }),
          );
          // Sort users alphabetically by name (case-insensitive)
          this.availableUsers.sort((a, b) => a.name.localeCompare(b.name));
        } else {
          this.availableUsers = [];
        }
      } catch (error) {
        this.availableUsers = [];
      } finally {
        this.loadingUsers = false;
      }
    },
    async openSwitchUserDialog() {
      this.loadingUsers = true;
      this.switchUserDialog = true;
      this.selectedUser = null;
      try {
        const response = await this.$axios.get("/jwt-token-check");
        if (response.data && response.data.availableAccounts) {
          this.availableUsers = response.data.availableAccounts.map(
            (account) => ({
              id: account.id,
              name: account.name,
              email: response.data.email,
            }),
          );
          // Sort users alphabetically by name (case-insensitive)
          this.availableUsers.sort((a, b) => a.name.localeCompare(b.name));
        } else {
          this.availableUsers = [];
        }
      } catch (error) {
        this.availableUsers = [];
      } finally {
        this.loadingUsers = false;
      }
    },
    async switchUser(accountId) {
      this.switchingUser = true;
      this.loadingUsers = false;
      try {
        // Switch account on backend
        await this.$axios.post("/gaa-user/switch-account", null, {
          params: { accountId },
        });

        // clear local storage
        localStorage.removeItem("token");
        localStorage.removeItem("vuex");
        delete this.$axios.defaults.headers.common["Authorization"];

        window.location.reload();
      } catch (error) {
        this.switchingUser = false;
        if (this.addErrorMessage) this.addErrorMessage(error);
        this.$router.push("/login");
      }
    },
  },
};
</script>

<style></style>
